/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.modals.dedupe.controllers', [
  'ui.router',
  'acme.common.factory.gridState',
  'acme.common.factory.gridDefinition',
  'acme.common.service.helpers'
])

.controller('DedupeModalController', [
  '$scope', '$uibModalInstance', 'HelpersService',
  'CardholderData',
  'CustomerDuplicatesData',
  'ShowCustomers',
  function(
    $scope, $uibModalInstance, HelpersService,
    CardholderData,
    CustomerDuplicatesData,
    ShowCustomers
  ) {

    $scope.dedupeModal = {

      model: {},

      index: null,
      cardholder: {},
      duplicates: [],
      showCustomers: ShowCustomers || false,

      init: function() {
        this.processCardholder();
        this.processDuplicates();
        this.footerInfo = this.duplicates.length + (this.duplicates.length > 1 ? ' possible matches' : ' possible match');
      },

      processCardholder: function() {
        var informationEntered = CustomerDuplicatesData.originalCardholder || CardholderData.cardholder;
        this.index = CardholderData.index;
        this.cardholder = Object.assign({}, informationEntered);
        this.cardholder.fullName = this.getFullName(this.cardholder);
      },

      processDuplicates: function() {
        var self = $scope.dedupeModal;
        var match = CustomerDuplicatesData.match || null;
        this.duplicates = (CustomerDuplicatesData) ? CustomerDuplicatesData.possibleDuplicates.map(function(item) {
          item.selected = (match && match.id === item.id);
          item.name = self.getFullName(item);
          item.fullName = self.getFullName(item);
          return item;
        }) : [];
      },

      getFullName: function(cardholder) {
        return [
          HelpersService.cap(cardholder.prefix),
          cardholder.firstName,
          cardholder.middleName,
          cardholder.lastName
        ].filter(function(name) {
          return !!name;
        }).join(' ');
      },

      // @returns {'unknown'|'potential_match'|'selected_existing_customer'|'none_match'} status
      noneIsMatch: function() {
        $uibModalInstance.close({
          index: this.index,
          status: 'none_match',
          cardholder: this.cardholder,
          noneMatch: true
        });  
      },

      samePerson: function(cardholder) {
        $uibModalInstance.close({
          index: this.index,
          status: 'selected_existing_customer',
          cardholder: cardholder
        });
      },

      close: function() {
        $uibModalInstance.dismiss();
      },

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      }

    };

    $scope.dedupeModal.init();

}]);
